import type { MetricRole } from '../../types/config';

export type MetricColumnConfig = {
    key: string;
    title: string;
    editable: boolean;
    allowedDecimals: number;
    minValue: number | null;
    maxValue: number | null;
    preUnit: string;
    postUnit: string;
    groupName: string;
    formula?: string;
    dependencies?: string[];
    order: number;
    defaultVisible: boolean;
    /**
     * Backend visibility role. `fe_hidden` columns are kept for client-side
     * fe_formula math (cascade DAG) but MUST never be rendered / offered in
     * pickers. Absent means displayable (treated as `computed`).
     */
    role?: MetricRole;
};

/**
 * Shared visibility predicates for the backend `role` field. A missing role is
 * treated as `computed` (displayable). Kept in one place so every display,
 * request, and formula layer applies the exact same rule.
 *
 * - `isDisplayableMetric` — safe to render / offer in pickers, grids, KPI
 *   selectors, and to send to `/report/period-data` & promo-metric endpoints.
 * - `isFormulaOnlyMetric` — `fe_hidden`: exclude from every display surface and
 *   backend request, but STILL include in the client-side fe_formula namespace.
 */
export const isFormulaOnlyMetric = (metric: { role?: MetricRole }): boolean => metric.role === 'fe_hidden';

export const isDisplayableMetric = (metric: { role?: MetricRole }): boolean => !isFormulaOnlyMetric(metric);
